// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"e5227bd9","187":"8ab525ce","192":"4a6c821d","285":"20b7f1dc","304":"288cbb16","488":"e40a46d7","493":"524c8f39","520":"9c09023e","555":"c5a57944","570":"d59404dc","577":"9437bfbd","660":"c19fcbe8","663":"0e9ea391","836":"799aebd8"}[chunkId] + ".chunk.js";
};